import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";

const Contact = () => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const siteName = setting?.site_settings?.site_name;
  const pageData = useSelector(
    (state) => state.globalState.siteSetting?.pages.contact_us
  );
  return (
    <Layout>
      <Helmet>
        <title>Contact Us - {siteName}</title>
      </Helmet>

      <Container className="px-4 my-10">
        <div className="mx-5">
          <div dangerouslySetInnerHTML={{ __html: pageData }} />
        </div>
      </Container>
    </Layout>
  );
};

export default Contact;
